import * as fp from 'lodash/fp';

import {
  addHours,
  subHours,
  addMinutes,
  differenceInDays,
  startOfDay,
  subDays,
  format,
  toDate,
  isAfter,
  isEqual,
} from 'date-fns';

import { OperatingTime, Week } from '~/types/common';
import isInOperatingTime from './isInOperatingTime';

export default function checkValidPreOrderTime(
  operatingTime: OperatingTime,
  afterHours: number,
  beforeHours: number,
  pickMealTime: Date | null,
  now: Date,
): [boolean, Date] {
  if (!pickMealTime) return [false, new Date()];

  if (!isInOperatingTime(operatingTime, pickMealTime)) {
    return [false, new Date()];
  }

  const estimatedOrderTime = subHours(pickMealTime, afterHours);
  const diffDay = differenceInDays(startOfDay(estimatedOrderTime), startOfDay(now));

  if (isAfter(pickMealTime, addHours(now, beforeHours))) return [false, new Date()];

  if (fp.lt(diffDay, 0)) return [false, new Date()];

  const lastPreOrderTime = fp
    .times((index) => subDays(estimatedOrderTime, index))(diffDay + 1)
    .reduce<Date | null>((acc, checkDate) => {
      if (acc) return acc;

      const weekString = format(checkDate, 'EEE').toUpperCase() as Week;

      // 找當天最近時間段
      const schedule = ([...operatingTime[weekString]] || [])
        .sort((a, b) => b.start - a.start)
        .find(
          ({ start }) =>
            isAfter(estimatedOrderTime, addMinutes(startOfDay(checkDate), start)) ||
            isEqual(estimatedOrderTime, addMinutes(startOfDay(checkDate), start)),
        );
      if (!schedule) return acc;

      return toDate(
        Math.min(
          estimatedOrderTime.getTime(),
          addMinutes(startOfDay(checkDate), schedule.end).getTime(),
        ),
      );
    }, null);
  if (!lastPreOrderTime) return [false, new Date()];

  if (isAfter(now.getTime(), lastPreOrderTime.getTime())) return [false, lastPreOrderTime];

  return [true, lastPreOrderTime];
}
